import React from "react";
import { Box, Typography, Link } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import blackAizatronLogo from "../assets/Aizatron-logo_alt_black_trans.png";

const useStyles = makeStyles((theme) => ({
  footerContainer: {
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    backgroundColor: "#FFC629",
    textAlign: "center",
    position: "relative",
    bottom: 0,
  },
  footer: {
    fontSize: "0.8rem !important",
    fontFamily: "Raleway, sans-serif !important",
    color: "#747171",
  },
  link: {
    fontSize: "0.8rem !important",
    color: "#747171 !important",
    cursor: "pointer",
    textDecoration: "none !important",
    fontWeight: "bold !important",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "none",
    },
  },
}));

const Footer = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const handleTermsClick = () => {
    navigate("/terms-and-conditions");
  };

  return (
    <Box className={classes.footerContainer}>
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <img
          src={blackAizatronLogo}
          alt="Aizatron Logo"
          style={{ width: "120px", height: "auto" }}
        />
        <Box>
          <Typography className={classes.footer}>
            Copyright &copy; ACE 2025 |
            <Link
              onClick={handleTermsClick}
              className={classes.link}
              style={{ marginLeft: "0.2rem" }}
            >
              Terms and Conditions
            </Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
